import { useTranslation } from 'react-i18next'
import useContact from '@/containers/SubscriptionFormPageNew/Components/Contact/useContact'

const REVIEW_LANGUAGE_REQUIRED_COUNTRIES = ['be']
const DEFAULT_REVIEW_LANGUAGE_BY_COUNTRY = { be: 'FR' }

// Trustpilot only supports French and Dutch reviews, unlike the shared Additional Sales language picker.
const getReviewLanguageOptions = t => [
  { FR: t('additionalSales:language_picker.french') },
  { NL: t('additionalSales:language_picker.dutch') },
]

const useReviewLanguage = () => {
  const { t } = useTranslation()
  const { country, createReviewsInteraction, reviewLanguage, customerUpdate } = useContact()

  const isReviewLanguageRequired = REVIEW_LANGUAGE_REQUIRED_COUNTRIES.includes(country)
  const isReviewLanguageMissing = isReviewLanguageRequired && !!createReviewsInteraction && !reviewLanguage

  const reviewLanguageOptions = getReviewLanguageOptions(t)
  const selectedLanguageLabel = reviewLanguageOptions.find(option => option[reviewLanguage])?.[reviewLanguage]

  const setReviewLanguage = language => {
    customerUpdate({ name: 'preferences', data: { reviewLanguage: language } })
  }

  const setReviewRequested = requested => {
    const defaultLanguage = DEFAULT_REVIEW_LANGUAGE_BY_COUNTRY[country] ?? null

    customerUpdate({
      name: 'preferences',
      data: {
        createReviewsInteraction: requested ? true : null,
        reviewLanguage: requested ? reviewLanguage || defaultLanguage : null,
      },
    })
  }

  return {
    country,
    reviewLanguage,
    reviewLanguageOptions,
    selectedLanguageLabel,
    isReviewLanguageRequired,
    isReviewLanguageMissing,
    setReviewLanguage,
    setReviewRequested,
  }
}

export default useReviewLanguage
